import { Routes, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import Page404 from "containers/Page404/Page404";
import ListingCarPage from "containers/ListingCarPage/ListingCarPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import AccountBilling from "containers/AccountPage/AccountBilling";
import PageContact from "containers/PageContact/PageContact";
import SiteHeader from "containers/SiteHeader";
import PageHome from "containers/PageHome/PageHome";
import ListingCarDetailPage from "containers/ListingDetailPage/listing-car-detail/ListingCarDetailPage";
import AvailableCarsPage from "containers/AvailableCarsPage/AvailableCarsPage";
import ComingSoon from "components/ComingSoon";
import BookingDetailsPage from "containers/BookingDetailsPage/BookingDetailsPage";
import CarListingDetailPage from "containers/CarListingDetailPage/CarListingDetailPage";
import TermsConditions from "components/Terms&Conditions/TermsConditions";
import PrivacyPolicy from "components/PrivacyPolicy/PrivacyPolicyPage";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/home-3", component: PageHome },
  { path: "/available-car", component: AvailableCarsPage },
  { path: "/vehicles", component: ListingCarPage },
  { path: "/booking-details", component: BookingDetailsPage },
  { path: "/listing-car-detail", component: ListingCarDetailPage },
  { path: "/checkout", component: CheckOutPage },
  { path: "/booking-request", component: PayPage },
  { path: "/account", component: AccountPage },
  { path: "/account-bookings", component: AccountSavelists },
  { path: "/account-billing", component: AccountBilling },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/terms-conditions", component: TermsConditions },
  { path: "/contact", component: PageContact },
  { path: "/coming-soon", component: ComingSoon },
  { path: "/car-listing-detail", component: CarListingDetailPage },
];

export enum AuthPages {
  Login,
  Signup,
  ForgotPass,
}

const MyRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <SiteHeader />

      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
        <Route element={<Page404 />} />
      </Routes>
      <Footer />
    </>
  );
};

export default MyRoutes;
